import { action, observable, makeObservable } from 'mobx';

import { ICurrentMediaDeviceIds, IDeviceInfo, IMediaDevices } from '@gem/call/CallStore/Call.types';

export class MediaDevices {
  @observable devices: IMediaDevices = {
    audioinput: [],
    audiooutput: [],
    videoinput: [],
  };

  @observable currentDeviceIds: ICurrentMediaDeviceIds = {
    audioinput: null,
    audiooutput: null,
    videoinput: null,
  };

  constructor(initialDevicesIds: ICurrentMediaDeviceIds) {
    makeObservable(this);
    this.currentDeviceIds = initialDevicesIds;
  }

  @action setDevices(kind: MediaDeviceKind, devices: IDeviceInfo[]): void {
    this.devices[kind] = devices;
  }

  @action setCurrentDeviceId(kind: MediaDeviceKind, deviceId: string | null): void {
    this.currentDeviceIds[kind] = deviceId;
  }

  @action setCurrentDevicesIds(devices: ICurrentMediaDeviceIds): void {
    this.currentDeviceIds = devices;
  }
}
